// extracted by mini-css-extract-plugin
export default {"header":"main_header__vyg6g","content":"main_content__psaWH","root":"main_root__kEZy0"};